/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import theme, { Content_Text } from "../Component/theme";

import Footer_FMS from "../2.FMS/Footer_FMS";
import Privacy_Policy_Modal from "../Component/Privacy_Policy_Modal";
import Terms_Modal from "../Component/Terms_Modal";
import image_main_dadem from "../image/image_main_dadem.png";
import image_main_dron from "../image/image_main_dron.png";
import image_main_GTP from "../image/image_main_GTP.png";
import image_main_na from "../image/image_main_na.png";
import image_main_naju from "../image/image_main_naju.png";
import image_main_naju_train from "../image/image_main_naju_train.png";
import image_main_petch from "../image/image_main_petch.png";
import image_main_rosepay from "../image/image_main_rosepay.png";
import image_main_shopping from "../image/image_main_shopping.png";
import Header_Main from "./Header_Main";
import Side_Main from "./Side_Main";

import ic_드라이브형 from "../image/ic_드라이브형.png";
import ic_드라이브형_sel from "../image/ic_드라이브형_sel.png";
import ic_주차시설관리 from "../image/ic_주차시설관리.png";
import ic_주차시설관리_sel from "../image/ic_주차시설관리_sel.png";
import ic_표준형 from "../image/ic_표준형.png";
import ic_표준형_sel from "../image/ic_표준형_sel.png";

import Platform_FMS_드라이브형 from "./Platform_FMS_드라이브형";
import Platform_FMS_주차시설 from "./Platform_FMS_주차시설";
import Platform_FMS_표준형 from "./Platform_FMS_표준형";

const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
  grid-template-rows: 80px 1fr 400px;
  grid-template-columns: 200px 1fr 200px;
  @media (max-width: 800px) {
    grid-template-rows: 40px 1fr 400px;
  }
`;
const Header = styled.header`
  grid-area: header;
  background: white;
  display: flex;
  align-items: center;
  border-width: 0px 0px 1px 0px;
  border-color: #f1f1f1;
  border-style: solid;
  justify-content: center;
  position: fixed;
  width: 100%;
  z-index: 10;
  @media (max-width: 800px) {
    padding-left: 15px;
  }
`;
const Main = styled.main`
  grid-area: main;
  padding-top: 10px;
  background-color: white;
`;
const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 20px;
`;
const Main_div2 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 20px;
`;

const Main_init_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 1500px) {
    padding: 0px 15px 0px 15px;
    padding-top: 50px;
  }
  @media (max-width: 800px) {
    padding: 0px;
    padding-top: 50px;
  }
`;

const Main_init_div2 = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

const Main_init_div3 = styled.div`
  display: flex;
  width: 200px;
  padding: 8px;
  border-radius: 16px;
  background-color: #fafafa;
  align-items: center;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 800px) {
    padding: 8px;
    width: 130px;
  }
`;

const Main_Content = styled.div`
  display: flex; /* Flexbox 사용 */
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media (max-width: 800px) {
    padding: 0px 15px;
  }
`;

const Main_Content2 = styled.div`
  flex: 1;
  display: flex;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 800px) {
    padding: 0px 2px 0px 2px;
  }
`;

const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 150px;
  margin-bottom: 30px;
  cursor: pointer;
`;

const Footer = styled.footer`
  grid-area: footer;
  background: #464646;
  color: white;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
`;

const Select_Button = styled.button`
  background-color: ${(props) => (props.$select ? "white" : "#FAFAFA")};
  padding: 6px 0px;
  width: 100%;
  border-radius: 8px;
  border-style: solid;
  border-width: ${(props) => (props.$select ? 1 : 0)}px;
  border-color: ${theme.colors.fontBlue};
  @media (max-width: 800px) {
    padding: 4px 0px;
  }
  cursor: pointer;
`;

const PP_IMG = styled(Image)`
  width: 400px;
  cursor: pointer;
  @media (max-width: 1500px) {
    width: 300px;
    padding: 0px 15px 0px 15px;
    padding-top: 50px;
  }
  @media (max-width: 800px) {
    width: 100%;
  }
`;

const PPT_Text = styled(Content_Text)`
  justify-self: flex-start;
`;

const Div_Null = styled.div`
  background-color: white;
  height: 5000px;
  width: 100%;
`;

const Platform_Select_div = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  @media (max-width: 800px) {
    margin-top: 0px;
    margin-bottom: 30px;
  }
`;

const Platform_Select_Image = styled(Image)`
  width: 200px;
  cursor: pointer;
  margin: 5px;
  @media (max-width: 800px) {
    width: 120px;
  }
`;

function Platform() {
  const navigation = useNavigate();
  const [privacy_policy, set_Privacy_Policy] = useState(false);
  const [terms, set_Terms] = useState(false);
  const close_privacy_policy = () => set_Privacy_Policy(false);
  const close_terms = () => set_Terms(false);
  const [select, set_Select] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [select_pp, set_Select_PP] = useState("");
  const [select_platform, set_Select_Platform] = useState("표준형");
  const go_Platform_Info = (item) => {
    navigation("/Platform_Info", { state: { data: item } });
  };
  const location = useLocation();

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const data = location.state;
    if (data && data !== undefined) {
      if (data.data !== undefined) {
        set_Select(data.data);
      }
    } else {
      set_Select("앱/웹");
    }

    // 사이즈 체크
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = ""; // Chrome에서는 returnValue 설정이 필요합니다.
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // 우클릭 금지
  useEffect(() => {
    const handleRightClick = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  useEffect(() => {
    // STEP 1: wcslog.js 스크립트가 이미 로드된 상태여야 함
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//wcs.naver.net/wcslog.js";
    document.body.appendChild(script);

    script.onload = () => {
      // STEP 2: _nasa 변수에 전환 추적 정보를 담음
      var _nasa = {};
      if (window.wcs) {
        _nasa["cnv"] = window.wcs.cnv("5", "1"); // 결제 금액 변수를 실제 값으로 대체
        window.wcs_do(_nasa);
      }
    };

    // Clean up the script when the component is unmounted
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container width={windowSize.width} height={windowSize.height}>
      <Header>
        <Header_Main page="포트폴리오" />
      </Header>
      {/* <Sidebar>사이드바 영역</Sidebar> */}
      <Main>
        <Side_Main />
        <Main_div>
          <Main_init_div>
            <Main_Content>
              <Content_Text $xxlarge $xbold>
                포트폴리오
              </Content_Text>
            </Main_Content>
          </Main_init_div>
        </Main_div>
        <Main_div style={{ paddingBottom: 20 }}>
          <Main_init_div3>
            <Main_Content2>
              <Select_Button
                $select={select === "앱/웹"}
                onClick={() => {
                  set_Select("앱/웹");
                }}
              >
                <Content_Text $blue={select === "앱/웹"} $lightGray>
                  앱/웹
                </Content_Text>
              </Select_Button>
            </Main_Content2>
            <Main_Content2>
              <Select_Button
                $select={select === "FMS"}
                onClick={() => {
                  set_Select("FMS");
                }}
              >
                <Content_Text $blue={select === "FMS"} $lightGray>
                  FMS
                </Content_Text>
              </Select_Button>
            </Main_Content2>
          </Main_init_div3>
        </Main_div>

        {select === "" && <Div_Null></Div_Null>}
        {select === "앱/웹" && select_pp === "" && (
          <>
            <Main_div2>
              <Main_init_div2
                style={{
                  paddingTop: 20,
                }}
              >
                <Main_Content>
                  <PP_IMG
                    src={image_main_dadem}
                    alt={image_main_dadem}
                    onClick={() => {
                      go_Platform_Info("Dadem");
                      window.scrollTo({ top: 0 });
                    }}
                  />
                  <PPT_Text $xlarge $darkGray>
                    다되는 예약제 대학배달앱
                  </PPT_Text>
                  <PPT_Text
                    $xxlarge
                    $xbold
                    style={{ marginTop: 4, marginBottom: 40 }}
                  >
                    다댐
                  </PPT_Text>
                </Main_Content>

                <Main_Content>
                  <PP_IMG
                    src={image_main_petch}
                    alt={image_main_petch}
                    onClick={() => {
                      go_Platform_Info("Petch");
                      window.scrollTo({ top: 0 });
                    }}
                  />
                  <PPT_Text $xlarge $darkGray>
                    동물병원 진료비 검색할 땐?
                  </PPT_Text>
                  <PPT_Text
                    $xxlarge
                    $xbold
                    style={{ marginTop: 4, marginBottom: 30 }}
                  >
                    펫치
                  </PPT_Text>
                </Main_Content>
                <Main_Content>
                  <PP_IMG
                    src={image_main_na}
                    alt={image_main_na}
                    onClick={() => {
                      go_Platform_Info("Na");
                      window.scrollTo({ top: 0 });
                    }}
                  />
                  <PPT_Text $xlarge $darkGray>
                    단역, 보조출연을 하고싶다면?
                  </PPT_Text>
                  <PPT_Text
                    $xxlarge
                    $xbold
                    style={{ marginTop: 4, marginBottom: 40 }}
                  >
                    뉴액터스
                  </PPT_Text>
                </Main_Content>
              </Main_init_div2>
            </Main_div2>
            <Main_div2 style={{ marginTop: 15 }}>
              <Main_init_div2
                style={{
                  paddingTop: 0,
                }}
              >
                <Main_Content>
                  <PP_IMG
                    src={image_main_rosepay}
                    alt={image_main_rosepay}
                    onClick={() => {
                      go_Platform_Info("Rosepay");
                      window.scrollTo({ top: 0 });
                    }}
                  />
                  <PPT_Text $xlarge $darkGray>
                    가맹점에서 10% 할인
                  </PPT_Text>
                  <PPT_Text
                    $xxlarge
                    $xbold
                    style={{ marginTop: 4, marginBottom: 30 }}
                  >
                    로즈페이
                  </PPT_Text>
                </Main_Content>
                <Main_Content>
                  <PP_IMG
                    src={image_main_naju}
                    alt={image_main_naju}
                    onClick={() => {
                      go_Platform_Info("Naju");
                      window.scrollTo({ top: 0 });
                    }}
                  />
                  <PPT_Text $xlarge $darkGray>
                    기념관 스탬프투어
                  </PPT_Text>
                  <PPT_Text
                    $xxlarge
                    $xbold
                    style={{ marginTop: 4, marginBottom: 30 }}
                  >
                    나주학생독립운동기념관
                  </PPT_Text>
                </Main_Content>
                <Main_Content>
                  <PP_IMG
                    src={image_main_naju_train}
                    alt={image_main_naju_train}
                    onClick={() => {
                      go_Platform_Info("Naju_Train");
                      window.scrollTo({ top: 0 });
                    }}
                  />
                  <PPT_Text $xlarge $darkGray>
                    역사이야기 랜덤 뽑기
                  </PPT_Text>
                  <PPT_Text
                    $xxlarge
                    $xbold
                    style={{ marginTop: 4, marginBottom: 30 }}
                  >
                    AI캐릭터봇을 활용한 역 ···
                  </PPT_Text>
                </Main_Content>
              </Main_init_div2>
            </Main_div2>
            <Main_div2 style={{ marginTop: 15 }}>
              <Main_init_div2
                style={{
                  paddingTop: 0,
                }}
              >
                <Main_Content>
                  <PP_IMG
                    src={image_main_GTP}
                    alt={image_main_GTP}
                    onClick={() => {
                      go_Platform_Info("GTP");
                      window.scrollTo({ top: 0 });
                    }}
                  />
                  <PPT_Text $xlarge $darkGray>
                    페스티벌 예약 및 투표
                  </PPT_Text>
                  <PPT_Text
                    $xxlarge
                    $xbold
                    style={{ marginTop: 4, marginBottom: 30 }}
                  >
                    광주학생탈렌트페스티벌 ···
                  </PPT_Text>
                </Main_Content>
                <Main_Content>
                  <PP_IMG
                    src={image_main_dron}
                    alt={image_main_dron}
                    onClick={() => {
                      go_Platform_Info("Dron");
                      window.scrollTo({ top: 0 });
                    }}
                  />
                  <PPT_Text $xlarge $darkGray>
                    농업 자동화 중계 서비스
                  </PPT_Text>
                  <PPT_Text
                    $xxlarge
                    $xbold
                    style={{ marginTop: 4, marginBottom: 30 }}
                  >
                    드론평야
                  </PPT_Text>
                </Main_Content>
                <Main_Content>
                  <PP_IMG
                    src={image_main_shopping}
                    alt={image_main_shopping}
                    onClick={() => {
                      go_Platform_Info("Shopping");
                      window.scrollTo({ top: 0 });
                    }}
                  />
                  <PPT_Text $xlarge $darkGray>
                    라이브커머스
                  </PPT_Text>
                  <PPT_Text
                    $xxlarge
                    $xbold
                    style={{ marginTop: 4, marginBottom: 30 }}
                  >
                    넘버원 쇼핑핫딜
                  </PPT_Text>
                </Main_Content>
              </Main_init_div2>
            </Main_div2>
          </>
        )}

        {select === "FMS" && (
          <Main_div style={{ flexDirection: "column" }}>
            <Platform_Select_div>
              <Platform_Select_Image
                onClick={() => {
                  set_Select_Platform("표준형");
                }}
                src={select_platform === "표준형" ? ic_표준형_sel : ic_표준형}
                alt={ic_표준형}
              />
              <Platform_Select_Image
                onClick={() => {
                  set_Select_Platform("드라이브형");
                }}
                src={
                  select_platform === "드라이브형"
                    ? ic_드라이브형_sel
                    : ic_드라이브형
                }
                alt={ic_드라이브형}
              />
              <Platform_Select_Image
                onClick={() => {
                  set_Select_Platform("주차시설 관리");
                }}
                src={
                  select_platform === "주차시설 관리"
                    ? ic_주차시설관리_sel
                    : ic_주차시설관리
                }
                alt={ic_주차시설관리}
              />
            </Platform_Select_div>
            {select_platform === "표준형" ? (
              <Platform_FMS_표준형 />
            ) : select_platform === "드라이브형" ? (
              <Platform_FMS_드라이브형 />
            ) : (
              <Platform_FMS_주차시설 />
            )}
          </Main_div>
        )}
      </Main>
      <Footer>
        <Footer_FMS />
      </Footer>
      <Privacy_Policy_Modal
        show={privacy_policy}
        onClose={close_privacy_policy}
      />
      <Terms_Modal show={terms} onClose={close_terms} />
    </Container>
  );
}

export default Platform;
